var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDumpTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9C2 7.89543 2.89543 7 4 7H7.17157C7.70201 7 8.21071 6.78929 8.58579 6.41421L10.4142 4.58579C10.7893 4.21071 11.298 4 11.8284 4H17C17.5523 4 18 4.44772 18 5C18 5.55228 17.5523 6 17 6H14V7H17.5963C18.265 7 18.8895 7.3342 19.2604 7.8906L21.5 11.25H14V12.75H22V16C22 16.5454 21.7817 17.0398 21.4277 17.4006C21.1592 16.3094 20.1741 15.5 19 15.5C17.6193 15.5 16.5 16.6193 16.5 18H12.5C12.5 16.6193 11.3807 15.5 10 15.5C9.1822 15.5 8.45611 15.8927 8 16.4998C7.54389 15.8927 6.8178 15.5 6 15.5C4.64029 15.5 3.53411 16.5855 3.50078 17.9372C2.63777 17.7154 2 16.9322 2 16V9ZM6 8.75C5.58579 8.75 5.25 9.08579 5.25 9.5V13.5C5.25 13.9142 5.58579 14.25 6 14.25C6.41421 14.25 6.75 13.9142 6.75 13.5V9.5C6.75 9.08579 6.41421 8.75 6 8.75ZM10 8.75C9.58579 8.75 9.25 9.08579 9.25 9.5V13.5C9.25 13.9142 9.58579 14.25 10 14.25C10.4142 14.25 10.75 13.9142 10.75 13.5V9.5C10.75 9.08579 10.4142 8.75 10 8.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19C19.5523 19 20 18.5523 20 18C20 17.4477 19.5523 17 19 17C18.4477 17 18 17.4477 18 18C18 18.5523 18.4477 19 19 19Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18C11 18.5523 10.5523 19 10 19C9.44771 19 9 18.5523 9 18C9 17.4477 9.44771 17 10 17C10.5523 17 11 17.4477 11 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDumpTruck);
export default __webpack_public_path__ + "static/media/dump-truck.abc35f1de93cfecfb6609dfb21dded5e.svg";
export { ForwardRef as ReactComponent };